import {
    INITIAL_CHART_TEMPLATE,
    ManageChartTemplateAction,
    ManageChartTemplateState,
} from './ManageChartTemplateReducer';
import React, { Dispatch, useContext } from 'react';

type ManageChartTemplateContextT = {
    state: ManageChartTemplateState;
    dispatch: Dispatch<ManageChartTemplateAction>;
};

export const ManageChartTemplateContext =
    React.createContext<ManageChartTemplateContextT>({
        state: INITIAL_CHART_TEMPLATE,
        dispatch: () => {},
    });

export const useManageChartTemplateContext = () =>
    useContext(ManageChartTemplateContext);
